module.exports = __webpack_public_path__ + "img/pr-4.4dc1541b.png";